import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { InViewTracking } from '@xing-com/crate-jobs-tracking';
import { Hyperlink } from '@xing-com/hyperlink';
import { spaceXL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const CONTEXTUAL_CONSENT_LINKS = {
  optOut: {
    de: 'https://privacy.xing.com/de/datenschutzerklaerung/informationen-die-wir-auf-grund-ihrer-nutzung-von-xing-automatisch-erhalten/bereitstellung-unseres-dienstes/kontextbezogene-messung',
    en: 'https://privacy.xing.com/en/privacy-policy/information-we-automatically-receive-through-your-use-of-xing/provision-of-our-service/contextual-measurement',
  },
  privacy: {
    de: 'https://privacy.xing.com/de/datenschutzerklaerung',
    en: 'https://privacy.xing.com/en/privacy-policy',
  },
} as const;

export const ContextualConsent: React.FC<{ isEligible: boolean }> = ({
  isEligible,
}) => {
  const { locale } = useIntl();
  const language = locale === 'de' ? 'de' : 'en';

  if (!isEligible) return null;

  return (
    <InViewTracking
      nwtTrackingOptions={{
        eventSchema: 'basic',
        event: 'entered_viewport',
        page: 'jobs/apply',
        element: 'contextual_consent_info',
      }}
    >
      <Container lineHeight="dense" size="small">
        <FormattedMessage
          id="JOBS_CONTEXTUAL_CONSENT_LEGAL_COPY"
          values={{
            optOutLink: (chunks) => (
              <Hyperlink
                href={CONTEXTUAL_CONSENT_LINKS.optOut[language]}
                target="_blank"
                rel="noopener"
              >
                {chunks}
              </Hyperlink>
            ),
            privacyLink: (chunks) => (
              <Hyperlink
                href={CONTEXTUAL_CONSENT_LINKS.privacy[language]}
                target="_blank"
                rel="noopener"
              >
                {chunks}
              </Hyperlink>
            ),
          }}
        />
      </Container>
    </InViewTracking>
  );
};

const Container = styled(BodyCopy)`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceXL};
`;
